import api from "./config/axiosWith401Redirect";

// The backend computes the amount and creates the Paymob intention with its
// own secret key; the browser only receives the checkout URL.
export const CreatePayment = async ({
  cart_items = [],
  shipping_address = null,
  booking_slots = [],
  onsite_visit_requests = [],
  coupon = null,
} = {}) => {
  const response = await api.post("/payment/create/", {
    cart_items: cart_items,
    shipping_address: shipping_address?.id ?? null,
    booking_slots: booking_slots,
    onsite_visit_requests: onsite_visit_requests,
    coupon: coupon,
  });

  return response?.data?.payment_url;
};

// "success" | "failed" | "pending", from the backend's record of the payment
// (confirmed by Paymob's signed webhook), never from the redirect URL
export const getPaymentStatus = async (orderId) => {
  const response = await api.get(`/payment/status/${orderId}/`);
  return response?.data?.status;
};
